__turbopack_context__.v({
  "badges": "PdpBadges-module__7T-juG__badges",
  "wrapper": "PdpBadges-module__7T-juG__wrapper",
});
